module.exports = __webpack_public_path__ + "img/piedi.8961ca1b.svg";